import api from "./client";

const BASE = "/users";

export async function updateAgreedToTerms(agreed) {
  const response = await api.patch(`${BASE}/agree-to-terms`, { agreed });

  return response.data;
}

export async function updateOnboarding(needsOnboarding) {
  const response = await api.patch(`${BASE}/onboarding`, { needsOnboarding });

  return response.data;
}

/**
 * pass only the fields you want to change - all are optional
 *
 * @param {object} settings
 * @param {string} [settings.displayName]
 * @param {boolean} [settings.dataUse]
 * @param {string} [settings.wellnesstimer]
 * @param {boolean} [settings.receiveEmailAlerts]
 * @param {boolean} [settings.receiveReports]
 * @param {boolean} [settings.adultActionImages]
 * @param {boolean} [settings.usesCastle]
 * @param {string} [settings.voice]
 *
 * @returns {Promise<User>}
 */
export async function updateSettings(settings) {
  const { data } = await api.patch(`${BASE}/me/settings`, settings);

  return data;
}

export async function updatePrivacy(dataUse) {
  const { data } = await api.patch(`${BASE}/me/privacy`, { dataUse });

  return data;
}
